export default function AvailableLanguages(){

    return [
        {key: 'de', name: 'Deutch'},
        {key: 'en', name: 'English'}
    ];

}
